import { createSagaAction } from '../../../shared/sagas'
import { createReducer } from '../../../shared/reducers'

// Constants
export const constants = {
  GET_SCHEDULE_DRAWING_DATES: createSagaAction('GET_SCHEDULE_DRAWING_DATES'),
  ADD_SCHEDULE_DRAWING_DATE: createSagaAction('ADD_SCHEDULE_DRAWING_DATE'),
  DELETE_SCHEDULE_DRAWING: createSagaAction('DELETE_SCHEDULE_DRAWING'),
  SCHEDULE_DRAWING_UPDATE: createSagaAction('SCHEDULE_DRAWING_UPDATE'),
  SCHEDULE_DRAWING_UPDATE_NOTE: createSagaAction('SCHEDULE_DRAWING_UPDATE_NOTE')
}

// Action Creators
export const actions = {
  getScheduleDrawingDates: ({ jobId }) => ({
    type: constants.GET_SCHEDULE_DRAWING_DATES.ACTION,
    jobId
  }),

  addScheduleDrawingDate: ({ jobId, userId, scheduleId }) => ({
    type: constants.ADD_SCHEDULE_DRAWING_DATE.ACTION,
    jobId,
    userId,
    scheduleId
  }),

  deleteScheduleDrawing: ({ jobId, scheduleId }) => ({
    type: constants.DELETE_SCHEDULE_DRAWING.ACTION,
    jobId,
    scheduleId
  }),

  updateDrawingDates: ({ jobId, userId, scheduleId, scheduleType, description, content }) => ({
    type: constants.SCHEDULE_DRAWING_UPDATE.ACTION,
    jobId,
    scheduleId,
    userId,
    scheduleType,
    description,
    content
  }),

  updateNotes: ({ jobId, userId, notes }) => ({
    type: constants.SCHEDULE_DRAWING_UPDATE_NOTE.ACTION,
    jobId,
    userId,
    notes
  })
}

// Reducer
const initialState = {}

export default createReducer(initialState, (state, action) => {
  switch (action.type) {
    case constants.AUTHENTICATION_LOGOUT:
      return initialState
    case constants.GET_SCHEDULE_DRAWING_DATES.ACTION:
      return { ...state, error: null, loading: true }
    case constants.GET_SCHEDULE_DRAWING_DATES.SUCCESS:
      return {
        ...state,
        scheduleDrawingDates: action.payload
      }
    case constants.GET_SCHEDULE_DRAWING_DATES.FAILED:
      return {
        error: action.message
      }
    case constants.SCHEDULE_DRAWING_UPDATE.SUCCESS:
      return {
        ...state
      }
    case constants.DELETE_SCHEDULE_DRAWING.SUCCESS:
      return {
        ...state
      }
    case constants.ADD_SCHEDULE_DRAWING_DATE.SUCCESS:
      return {
        ...state
      }
    case constants.SCHEDULE_DRAWING_UPDATE_NOTE.SUCCESS:
      return {
        ...state
      }
    default:
      return state
  }
})



// WEBPACK FOOTER //
// ./src/redux/modules/jobFunctions/scheduleDrawingActions.js